"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.formatData = formatData;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isFocus(direction1, direction2) {
  if (!direction1 || !direction2) return false;
  return direction1.value > 0 && direction2.value > 0 && direction1.value + direction2.value > 0.6;
}

function determineDirection(focuses) {
  var north = focuses.north,
      east = focuses.east,
      south = focuses.south,
      west = focuses.west;

  if (east && north && west) {
    return {
      direction: 'north',
      focusCount: 2
    };
  } else if (north && east && south) {
    return {
      direction: 'east',
      focusCount: 2
    };
  } else if (east && south && west) {
    return {
      direction: 'south',
      focusCount: 2
    };
  } else if (south && west && north) {
    return {
      direction: 'west',
      focusCount: 2
    };
  } else if (north && east) {
    return {
      direction: 'northEast',
      focusCount: 1
    };
  } else if (south && east) {
    return {
      direction: 'southEast',
      focusCount: 1
    };
  } else if (south && west) {
    return {
      direction: 'southWest',
      focusCount: 1
    };
  } else if (north && west) {
    return {
      direction: 'northWest',
      focusCount: 1
    };
  }

  return {
    focusCount: 0,
    direction: null
  };
}

function formatData(questionProfile) {
  var _questionProfile$coun = questionProfile.count,
      why = _questionProfile$coun.why,
      what = _questionProfile$coun.what,
      who = _questionProfile$coun.who,
      how = _questionProfile$coun.how;
  var total = why + what + who + how;
  var north = {
    value: why / total || 0,
    label: 'Why',
    key: 'why'
  };
  var east = {
    value: what / total || 0,
    label: 'What',
    key: 'what'
  };
  var south = {
    value: how / total || 0,
    label: 'How',
    key: 'how'
  };
  var west = {
    value: who / total || 0,
    label: 'Who',
    key: 'who'
  };
  var focuses = {};
  var blindspots = {};

  if (isFocus(north, east)) {
    focuses = _objectSpread(_objectSpread({}, focuses), {}, {
      north: true,
      east: true
    });
    blindspots = _objectSpread(_objectSpread({}, blindspots), {}, {
      south: true,
      west: true
    });
  }

  if (isFocus(north, west)) {
    focuses = _objectSpread(_objectSpread({}, focuses), {}, {
      north: true,
      west: true
    });
    blindspots = _objectSpread(_objectSpread({}, blindspots), {}, {
      south: true,
      east: true
    });
  }

  if (isFocus(south, east)) {
    focuses = _objectSpread(_objectSpread({}, focuses), {}, {
      south: true,
      east: true
    });
    blindspots = _objectSpread(_objectSpread({}, blindspots), {}, {
      north: true,
      west: true
    });
  }

  if (isFocus(south, west)) {
    focuses = _objectSpread(_objectSpread({}, focuses), {}, {
      south: true,
      west: true
    });
    blindspots = _objectSpread(_objectSpread({}, blindspots), {}, {
      north: true,
      east: true
    });
  }

  var _determineDirection = determineDirection(focuses),
      direction = _determineDirection.direction,
      focusCount = _determineDirection.focusCount;

  var hasFocus = focusCount > 0;
  return {
    data: {
      north: north,
      east: east,
      south: south,
      west: west
    },
    focuses: focuses,
    blindspots: blindspots,
    direction: direction,
    focusCount: focusCount,
    hasFocus: hasFocus
  };
}

var _default = {
  formatData: formatData
};
exports.default = _default;
//# sourceMappingURL=focus.js.map